// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2oeu0","content":"styles_content__nl8xm","tableWrap":"styles_tableWrap__2QyOd"};